import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsImageLibraryListInfoParm } from "./wsImageLibraryListInfoParm";
import { wsImageUploadInfo } from "./wsImageUploadInfo";
import { wsImageLibraryAssocGroupListInfoParm } from "./wsImageLibraryAssocGroupListInfoParm";
import { wsImageLibraryAssocGroupModifyInfoParm } from "./wsImageLibraryAssocGroupModifyInfoParm";
import { wsImageLibraryDeleteParm } from "./wsImageLibraryDeleteParm";
import { wsImageLibraryCopyParm } from "./wsImageLibraryCopyParm";
import { wsImageLibraryRenameParm } from "./wsImageLibraryRenameParm";
import { wsImageLibrarySetDistrictParm } from "./wsImageLibrarySetDistrictParm";
import { wsImageLibraryEditInfo } from "../shared/wsImageLibraryEditInfo";
import { wsImageLibraryEditUpdateInfo } from "./wsImageLibraryEditUpdateInfo";

@Injectable()
export class DataService_imagemaint {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	getData
	//
	//-----------------------------------------------------------------------------------------------------
	getData() {
		var postResult$ = new Subject();
		var url = "PhotoID/GetData";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageGroupSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	ImageGroupSelectList() {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageGroupSelectList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibrarySelectListByGroupID
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibrarySelectListByGroupID(SchoolID: number, ImageLibraryGroupID: number) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageLibrarySelectListByGroupID";

		let parms: wsImageLibraryListInfoParm = {
			SchoolID: SchoolID,
			ImageLibraryGroupID: ImageLibraryGroupID,
		};

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryUpload
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryUpload(parms: wsImageUploadInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/ExecuteImageLibraryInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryAssociationGroupSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryAssociationGroupSelectList(parms: wsImageLibraryAssocGroupListInfoParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageLibraryAssociationGroupSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryAssociationGroupModify
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryAssociationGroupModify(parms: wsImageLibraryAssocGroupModifyInfoParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageLibraryAssociationGroupModify";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryDelete
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryDelete(ImageLibraryID: string) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageLibraryDelete";

		let parms: wsImageLibraryDeleteParm = {
			ImageLibraryID: ImageLibraryID,
		};

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryCopy
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryCopy(parms: wsImageLibraryCopyParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageLibraryCopy";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryRename
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryRename(parms: wsImageLibraryRenameParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageLibraryRename";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibrarySetDistrict
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibrarySetDistrict(parms: wsImageLibrarySetDistrictParm) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageLibrarySetDistrict";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryEditGet
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryEditGet(parms: wsImageLibraryEditInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageLibraryEditGet";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ImageLibraryEditUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	ImageLibraryEditUpdate(parms: wsImageLibraryEditUpdateInfo) {
		var postResult$ = new Subject();
		var url = "PhotoID/ImageLibraryEditUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
